export const viewCheckbookFilters: { filters: any[] }[] = [
  {
    filters: [],
  },
  {
    filters: [{ field: 'isDeleted', value: true, operator: 'neq' }],
  },
  {
    filters: [
      { field: 'isActive', value: true, operator: 'eq' },
      { field: 'isDeleted', value: true, operator: 'neq' },
    ],
  },
  {
    filters: [
      { field: 'isActive', value: false, operator: 'eq' },
      { field: 'isDeleted', value: true, operator: 'neq' },
    ],
  },
  {
    filters: [{ field: 'isDeleted', value: true, operator: 'eq' }],
  },
];
